import Image from "next/legacy/image";

import * as S from "./LandingPageResponsibilityOrganism.style";
import {
  landingResponsibilityDesktopData,
  landingResponsibilityMobileData,
} from "../../../../models/landing/responsibility/responsibility.model";
import plus from "/public/images/landing/responsibility/plus.png";
import SpecialSessionMolecule from "@/components/molecules/LandingPageMolecules/LandingPageResponsibilityMolecule/SpecialSessionMolecule";
import { useRef } from "react";
export let applySupportRef;

const LandingPageResponsibilityOrganism = ({ course }: { course: string }) => {
  applySupportRef = useRef();
  const courseText = { pm: "PM과", mkt: "마케터와" };
  return (
    <S.Wrapper ref={applySupportRef}>
      <S.Title>
        탄탄한 취업 지원으로
        <br />
        커리어 시작부터 성장까지 확실히.
      </S.Title>
      <S.Carousel>
        {landingResponsibilityMobileData(courseText[course]).map(
          (responsibility) => (
            <S.Responsibility key={responsibility.title}>
              <S.Number>{responsibility.number}</S.Number>
              <S.Session>{responsibility.title}</S.Session>
              <S.Image>
                <Image
                  src={responsibility.img}
                  alt="image"
                  layout="fill"
                  objectFit="cover"
                  quality={100}
                  loading="lazy"
                />
              </S.Image>
              <S.Desc>{responsibility.desc}</S.Desc>
            </S.Responsibility>
          )
        )}
      </S.Carousel>
      <S.Grid>
        {landingResponsibilityDesktopData(courseText[course]).map(
          (responsibility) => (
            <S.Card key={responsibility.title}>
              <S.Number>{responsibility.number}</S.Number>
              <S.Session>{responsibility.title}</S.Session>
              <S.Image>
                <Image
                  src={responsibility.img}
                  alt="image"
                  quality={100}
                  loading="lazy"
                />
              </S.Image>
              <S.Desc>{responsibility.desc}</S.Desc>
            </S.Card>
          )
        )}
      </S.Grid>

      {course === "pm" ? (
        <>
          <S.PlusImage>
            <Image src={plus} alt="plus-image" />
          </S.PlusImage>{" "}
          <SpecialSessionMolecule />
        </>
      ) : null}
    </S.Wrapper>
  );
};

export default LandingPageResponsibilityOrganism;
